import { render, staticRenderFns } from "./PlotDetails.vue?vue&type=template&id=79ed0b2b"
import script from "./PlotDetails.vue?vue&type=script&lang=js"
export * from "./PlotDetails.vue?vue&type=script&lang=js"
import style0 from "./PlotDetails.vue?vue&type=style&index=0&id=79ed0b2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports